import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/percentage-calculator")({
  component: PercentageCalculatorLayout,
});

function PercentageCalculatorLayout() {
  return <Outlet />;
}
